import { DURING_STAY_SURVEY_SEND_ANSWER_SUCCESS } from './../const';

function action(data, token, lang, context) {
  return { type: DURING_STAY_SURVEY_SEND_ANSWER_SUCCESS, data, token, lang, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/duringStaySurveySendAnswerSuccess.js